import { render } from "./whiteboard-palette.vue?vue&type=template&id=038957bd&scoped=true&ts=true"
import script from "./whiteboard-palette.ts?vue&type=script&lang=ts&external"
export * from "./whiteboard-palette.ts?vue&type=script&lang=ts&external"

import "./whiteboard-palette.vue?vue&type=style&index=0&id=038957bd&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-038957bd"]])

export default __exports__